/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/CurrentUserInfoStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreLoadingState } from "TFS/Views/ProjectOverviewPage/Shared/Contracts";
import { CurrentUserPermission } from "TFS/Views/ProjectOverviewPage/Shared/Models";

export interface CurrentUserInfoState {
    loadingState: StoreLoadingState;
    currentUserPermission: CurrentUserPermission;
}

export class CurrentUserInfoStore extends Store {
    private _state: CurrentUserInfoState = {
        loadingState: StoreLoadingState.Loading,
        currentUserPermission: {
            isStakeHolder: false,
            hasManageProjectPropertiesPermission: false,
            hasProjectLevelEditPermission: false,
            isAdmin: false,
            isLoggedIn: false
        }
    };

    public getState(): CurrentUserInfoState {
        return this._state;
    }

    public loadCurrentUserInfo = (payload: CurrentUserPermission): void => {
        this._state.loadingState = StoreLoadingState.Loaded;
        this._state.currentUserPermission = payload;

        this.emitChanged();
    };

    public loadCurrentUserInfoFailed = (): void => {
        this._state.loadingState = StoreLoadingState.LoadFailed;
        this.emitChanged();
    };
}
